import type { ReactNode } from 'react'
import { AppFooter } from '@/components/molecules/app-footer'
import { GtmHalftoneBackground } from '@/features/gtm/components/gtm-halftone-background'
import { GtmLandingHeader } from '@/features/gtm/components/gtm-landing-header'
import { useGtmTheme } from '@/features/gtm/components/use-gtm-theme'

type GtmPageShellProps = {
  children: ReactNode
  /** Calmer background for reading pages (articles). */
  quiet?: boolean
  hideTelegram?: boolean
}

/**
 * Frame for public Laplace x GTM content pages (the blog): GTM theme, the
 * halftone background, the landing header and the footer. The GTM
 * counterpart of MarketingPageShell, which keeps the old dark look for the
 * pages that still use it.
 */
export function GtmPageShell({
  children,
  quiet = false,
  hideTelegram = false,
}: GtmPageShellProps) {
  useGtmTheme()

  return (
    <div className="theme-gtm relative isolate min-h-screen overflow-x-clip bg-background text-foreground">
      <GtmHalftoneBackground quiet={quiet} />
      <div className="relative z-10 mx-auto max-w-7xl px-6 pt-6 sm:px-8 lg:px-12">
        <GtmLandingHeader />
        <main className="pb-20">{children}</main>
      </div>
      <AppFooter className="relative z-10" hideTelegram={hideTelegram} />
    </div>
  )
}
